var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function TabletIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 18V16H3V18H11C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18H21ZM21 6H3V14H21V6ZM1 5.00087C1 4.44811 1.44943 4 2.00246 4H21.9975C22.5512 4 23 4.44463 23 5.00087V18.9991C23 19.5519 22.5506 20 21.9975 20H2.00246C1.44882 20 1 19.5554 1 18.9991V5.00087Z", fill: "" })));
}
export var TabletIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: TabletIconInner }, props))); };
//# sourceMappingURL=TabletIcon.js.map